import { render, staticRenderFns } from "./distributorDeclaration.vue?vue&type=template&id=99f9e336&scoped=true"
import script from "./distributorDeclaration.vue?vue&type=script&lang=js"
export * from "./distributorDeclaration.vue?vue&type=script&lang=js"
import style0 from "./distributorDeclaration.vue?vue&type=style&index=0&id=99f9e336&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9e336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f9e336')) {
      api.createRecord('99f9e336', component.options)
    } else {
      api.reload('99f9e336', component.options)
    }
    module.hot.accept("./distributorDeclaration.vue?vue&type=template&id=99f9e336&scoped=true", function () {
      api.rerender('99f9e336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distributorDeclaration/distributorDeclaration.vue"
export default component.exports